import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckToastComponent } from './check-toast.component';

@NgModule({
    declarations: [CheckToastComponent],
    exports: [CheckToastComponent],
    imports: [
        CommonModule,
    ],
})
export class CheckToastModule { }
